export default function timeToDHMFormat(totalHour: number) {
    const totalMinutes = totalHour * 60;
    let resultArray = [];

    const minutesInDay = 24 * 60;
    const minutesInWeek = 7 * minutesInDay;

    const weeks = Math.floor(totalMinutes / minutesInWeek);
    const days = Math.floor((totalMinutes % minutesInWeek) / minutesInDay);
    const hours = Math.floor((totalMinutes % minutesInDay) / 60);
    const minutes = totalMinutes % 60;

    if (weeks) {
        resultArray.push(`${weeks}н.`);
    }
    if (days) {
        resultArray.push(`${days}д.`);
    }
    if (hours) {
        resultArray.push(`${hours}ч.`);
    }
    if (minutes) {
        resultArray.push(`${minutes}м.`);
    }

    return resultArray.join(" ");
}
